import React, { useMemo } from 'react';
import { OctagonAlert } from 'lucide-react';
import issuesPlannerTestData from './data/issuesPlannerTestData';
import { filterPlannerPool } from './plannerListFilters';
import styles from './plannerPage.module.css';

export function IssuesPlannerTab({ distanceLimitMi, containerSearch }) {
  const items = useMemo(
    () =>
      filterPlannerPool(
        issuesPlannerTestData,
        distanceLimitMi,
        containerSearch
      ),
    [distanceLimitMi, containerSearch]
  );

  return (
    <div className={styles.issuesSection}>
      <div className={styles.liveUnloadHeader}>
        <OctagonAlert
          className={styles.liveUnloadClock}
          size={24}
          strokeWidth={2}
          color="#131517"
          aria-hidden
        />
        <div>
          <h2 className={styles.liveUnloadTitle}>Planner issues</h2>
          <p className={styles.liveUnloadSubtitle}>
            Containers that could not be fully matched or booked.
          </p>
        </div>
      </div>

      <div
        className={styles.issuesList}
        role="list"
        aria-label="Planner issues">
        {items.length === 0 ? (
          <p className={styles.issuesPlaceholder}>
            No planner issues match your filters.
          </p>
        ) : (
          items.map((issue) => (
            <article
              key={issue.id}
              className={`${styles.issueCard} ${
                issue.severity === 'error'
                  ? styles.issueCardError
                  : styles.issueCardWarning
              }`}
              role="listitem">
              <div className={styles.issueCardTop}>
                <span
                  className={styles.issueSeverity}
                  data-severity={issue.severity}>
                  {issue.severity === 'error' ? 'Error' : 'Warning'}
                </span>
                <h3 className={styles.issueTitle}>{issue.title}</h3>
              </div>
              <p className={styles.issueMessage}>{issue.message}</p>
              <dl className={styles.issueMeta}>
                <div className={styles.issueMetaRow}>
                  <dt>Container</dt>
                  <dd>{issue.container}</dd>
                </div>
                <div className={styles.issueMetaRow}>
                  <dt>Job</dt>
                  <dd>{issue.jobRef}</dd>
                </div>
                <div className={styles.issueMetaRow}>
                  <dt>Planner</dt>
                  <dd>{issue.plannerType}</dd>
                </div>
                <div className={styles.issueMetaRow}>
                  <dt>Detected</dt>
                  <dd>{issue.detectedAt}</dd>
                </div>
              </dl>
            </article>
          ))
        )}
      </div>
    </div>
  );
}
